var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgR4Venezuela = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44.4 25",
    style: {
      enableBackground: "new 0 0 44.4 25"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#000000;}\r\n\t.st2{fill:#E55729;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,12.7v-0.2V4.7c-2.6,3.3-5,6.3-7.4,9.4h0.1c2.4,0,4.8,0,7.3,0.1v-0.1V12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,16.5c0.6-0.1,1.3-0.1,2-0.1v-0.1c-0.7,0-1.3,0-2,0.1V16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,16.4c0.6-0.1,1.3-0.1,2-0.1C33.3,16.3,32.7,16.3,32,16.4L32,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34,16.3c-0.7,0-1.4,0-2,0.1C32.7,16.3,33.3,16.3,34,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,17v0.1c0,1.3,0,2.5,0,3.9c0,0.7-0.1,0.9-0.8,0.9c-2.7,0-5.4,0-8.1,0c-0.5,0-0.8-0.1-1.2-0.4 c-2.7-2.1-5.4-4.3-8.1-6.4c-0.2-0.1-0.5-0.2-0.5-0.7c0.8,0.1,1.5,0,2.3-0.2c3.1-0.9,5-3.7,4.8-7.1c-0.2-2.8-2.5-5.1-5.6-5.5 c-2.8-0.3-5.5,0-8.3-0.1c-0.8-0.1-1.1,0.1-1.1,1c0,6,0,11.9,0,17.9c-0.1,0.8,0.1,1.1,1,1.1c0.9,0,1.1-0.4,1.1-1.2 c0-5.3,0-10.6,0-15.9c0-0.7,0.1-0.9,0.9-0.9c1.9,0,3.8,0,5.7,0c1.9,0,4,1.5,4.2,3.6c0.2,1.6-0.9,3.6-2.5,4.5 c-1.7,0.9-3.5,0.6-5.2,0.7c-0.4,0-1-0.3-1.1,0.3c0,0.7-0.3,1.7,0.4,2.2c3.6,2.6,7.2,5.3,10.6,8.2c0.5,0.4,1.1,0.9,1.9,0.9 c3.6,0,7.2,0,10.8,0c0.7,0,0.8-0.3,0.8-0.9c0-2,0-3.9,0-5.9V17v-0.6c-0.7,0-1.4,0-2,0.1V17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,4.7v7.9v0.2v1.3v0.1c0.7,0,1.3,0,2,0v-0.1v-1.3v-0.2c0-3.4,0-6.9,0-10.4c0-0.3,0.2-0.9-0.3-0.9 c-0.7-0.1-1.5-0.4-2.2,0.5c-1.9,2.6-4,5.1-6,7.7c-1.2,1.6-2.5,3-3.6,4.7c0.9,0,1.8,0,2.7-0.1C27,11,29.4,8,32,4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.3,14.2c-1.1,0.1-2.2,0-3.3,0c-0.7,0-1.3,0-2,0c-2.5-0.1-4.9-0.1-7.3-0.1h-0.1c-0.9,0.1-1.8,0.1-2.7,0.1 c-0.4,2-0.4,2.1,1.6,2.1c2.8,0,5.7,0,8.5,0c0.7,0,1.3,0,2,0c1.1,0,2.2,0,3.3,0c0.8,0.1,1.8-0.3,1.8-1S38.2,14.2,37.3,14.2z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgR4Venezuela);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/R4VENEZUELA.549975ae40103b3b5a399340871322cf.svg";